module.exports = __webpack_public_path__ + "img/bg-disable.2612f46a.png";